import { render, staticRenderFns } from "./productClassInfoIntroduction.vue?vue&type=template&id=0f7c835f&scoped=true&"
import script from "./productClassInfoIntroduction.vue?vue&type=script&lang=js&"
export * from "./productClassInfoIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./productClassInfoIntroduction.vue?vue&type=style&index=0&id=0f7c835f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c835f",
  null
  
)

export default component.exports